<template>
  <div class="tag-section">
    <article class="box">
      <section-header
        :label="label" :editing="editing" :message="error"
        @edit="edit" @save="validate" @cancel="cancel"
      ></section-header>
      <div class="tags" v-if="!editing && this.tags.length > 0">
        <div class="tag is-light cursor-pointer" v-for="(tag, index) in tags" :key="index" @click="clickTag(tag)">{{tag}}</div>
      </div >
      <tag-selector v-if="editing" v-model="editableTags" :chosenTags="editableTags" :label="label"></tag-selector>
      <span v-if="!editing && this.tags.length === 0">{{placeholder}}</span>
    </article>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import SectionHeader from './SectionHeader'

import state from '../../state'
import TagSelector from '@/components/Inputs/TagSelector'

export default {
  mixins: [componentState],
  components: {
    SectionHeader,
    TagSelector
  },
  props: ['tags', 'placeholder', 'label', 'callbackName'],
  data: function () {
    return {
      editing: false,
      editableTags: [],
      error: ''
    }
  },
  mounted: function () {
    this.setDefaultValue()
  },
  watch: {
    tags: function () {
      this.setDefaultValue()
    }
  },
  methods: {
    setDefaultValue: function () {
      this.editableTags = this.tags.slice(0)
    },
    edit: function () {
      this.editing = true
      this.$emit('startEdit')
    },
    cancel: function () {
      this.setDefaultValue()
      this.$emit('stopEdit')
      this.editing = false
    },
    validate: function () {
      if (this.tags.join(',') === this.editableTags.join(',')) {
        return this.cancel()
      }
      return this.save()
    },
    save: function () {
      this.error = ''
      this._callback(state.callbacks.save[this.callbackName], this.editableTags).then(() => {
        this.editing = false
      }).catch(() => {
        this.error = 'Error while saving tag'
      })
    },
    clickTag: function (tag) {
      this.$router.push({ name: 'viewAll', query: { tag: encodeURIComponent(tag) } })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
  .tag-section{
    padding: 1rem 0;

    .tags {
      margin-top: 0.5rem;
    }
  }
</style>
